import classcat from "classcat";
import React from "react";

import { IconArrowDownCircle } from "@touchtech/web-baselayer-ui";

import { WidgetItem as WidgetItemType } from "@is/types";

import css from "./WidgetItem.module.css";
import WidgetProductItem from "./WidgetProductItem";
import useManageWidgetItem from "./hooks/useManageWidgetItem";

type Props = {
  widget: WidgetItemType;
  contentItemId?: string;
  className?: string;
  onShowAll?: (id: string) => void;
  onShowMore?: (id: string) => void;
  isBasketWidget?: boolean;
};

const WidgetItem = ({
  widget,
  className,
  contentItemId,
  onShowAll,
  onShowMore,
  isBasketWidget,
}: Props) => {
  const {
    items,
    showViewMoreButton,
    showViewAllButton,
    t,
    handleViewMore,
    handleShowAllItems,
    handleItemClick,
    getAnimationDelayIndex,
    widgetRef,
    handleQuickAdd,
    quickAddToBasketItem,
    handleQuickAddRemoveItem,
    handleQuickAddLayerClick,
    showNoItemsMessage,
  } = useManageWidgetItem({
    widget,
    contentItemId,
    onShowAll,
    onShowMore,
    isBasketWidget,
  });

  if (!items.length) {
    return null;
  }

  return (
    <div
      className={classcat([
        css.container,
        { [css.expanded]: widget.isExpanded },
        className,
      ])}
      ref={widgetRef}
    >
      <div className={css.titleContainer}>
        <div className={classcat(["text-headline-3xl", css.title])}>
          {t(widget.title)}
        </div>
        {showViewMoreButton && (
          <button onClick={handleViewMore} className={css.viewMoreButton}>
            <IconArrowDownCircle />
            <span>{t("View more like this")}</span>
          </button>
        )}
      </div>
      <div className={css.itemsContainer}>
        {items?.map((item, index) => (
          <WidgetProductItem
            onClick={handleItemClick}
            key={`${widget.id}-${item.id}`}
            item={item}
            animationDelayIndex={getAnimationDelayIndex(index)}
            onQuickAddToBasket={handleQuickAdd}
            quickAddToBasketItem={
              quickAddToBasketItem?.widgetProductItemId ===
              item?.widgetProductItemId
                ? quickAddToBasketItem
                : null
            }
            onQuickAddToBasketRemoveItem={handleQuickAddRemoveItem}
            quickAddToBasketMode={!!quickAddToBasketItem}
            onQuickAddToBasketLayerClick={handleQuickAddLayerClick}
            widgetType={widget.type}
          />
        ))}
      </div>
      {showViewAllButton && (
        <div className={css.viewMoreButtonContainer}>
          <button onClick={handleShowAllItems} className={css.viewMoreButton}>
            <IconArrowDownCircle />
            <span>{t("View more like this")}</span>
          </button>
        </div>
      )}
      {showNoItemsMessage && (
        <div
          className={classcat([
            css.viewMoreButtonContainer,
            css.viewMoreButton,
          ])}
        >
          <span>{t("No more items to load")}</span>
        </div>
      )}
    </div>
  );
};

export default WidgetItem;
